// extracted by mini-css-extract-plugin
export default {"loader":"BIve2g"};